module.exports = __webpack_public_path__ + "img/FLOWER HAT BN.4188822.svg";